
export * from 'ui-permit/shared-components/constants'
export * from './shared-constants';

export const PERMIT_ACTION_PREFIX = 'IW_'; // Use with actions to prevent site-wide action namespace collisions.

// permit
export const GET_PERMIT = `${PERMIT_ACTION_PREFIX}GET_PERMIT`;
export const GET_PERMIT_ERROR = `${PERMIT_ACTION_PREFIX}GET_PERMIT_ERROR`;
export const GET_PERMIT_RULES_ERROR = 'GET_PERMIT_RULES_ERROR';
export const SET_PERMIT_TYPE = `${PERMIT_ACTION_PREFIX}SET_PERMIT_TYPE`;
export const SET_PERMIT_DATE = `${PERMIT_ACTION_PREFIX}SET_PERMIT_DATE`;
export const SET_SELECTED_DIVISION = `${PERMIT_ACTION_PREFIX}SET_SELECTED_DIVISION`;
export const SET_SELECTED_START_DATE = `${PERMIT_ACTION_PREFIX}SET_SELECTED_START_DATE`;
export const SET_SELECTED_END_DATE = `${PERMIT_ACTION_PREFIX}SET_SELECTED_END_DATE`;
export const SET_DISTRICTS = 'SET_DISTRICTS';
export const GET_COOPERATORS = `${PERMIT_ACTION_PREFIX}GET_COOPERATORS`;
export const GET_COOPERATORS_ERROR = `${PERMIT_ACTION_PREFIX}GET_COOPERATORS_ERROR`;
export const GET_COOPERATOR = `${PERMIT_ACTION_PREFIX}GET_COOPERATOR`;
export const GET_COOPERATOR_ERROR = `${PERMIT_ACTION_PREFIX}GET_COOPERATOR_ERROR`;
export const SET_QUESTIONNAIRE_ANSWERS = `${PERMIT_ACTION_PREFIX}SET_QUESTIONNAIRE_ANSWERS`;
export const SET_ACTIVE_TAB = `${PERMIT_ACTION_PREFIX}SET_ACTIVE_TAB`;
export const SET_DIV_SEARCH_CRITERIA = `${PERMIT_ACTION_PREFIX}SET_DIV_SEARCH_CRITERIA`;
export const SET_VALIDATION_ERROR = `${PERMIT_ACTION_PREFIX}SET_VALIDATION_ERROR`;
export const GET_RECAREA = `${PERMIT_ACTION_PREFIX}GET_RECAREA`;
export const GET_RECAREA_ERROR = `${PERMIT_ACTION_PREFIX}GET_RECAREA_ERROR`;
export const CLEAR_PERMIT = `IW_CLEAR_PERMIT`;
export const GET_STAYLIMIT_RULE = `IW_GET_STAYLIMIT_RULE`;
export const GET_STAYLIMIT_RULE_ERROR = `IW_GET_STAYLIMIT_RULE_ERROR`;
export const GET_AGGREGATE_SEASON_RULES = `${PERMIT_ACTION_PREFIX}GET_AGGREGATE_SEASON_RULES`;
export const GET_AGGREGATE_SEASON_ERROR = `${PERMIT_ACTION_PREFIX}GET_AGGREGATE_SEASON_ERROR`;
export const CLEAR_IW_FETCH_ISSUANCE_ERROR = 'CLEAR_IW_FETCH_ISSUANCE_ERROR';
export const SET_EXISTING_ISSUANCE = `${PERMIT_ACTION_PREFIX}SET_EXISTING_ISSUANCE`;
export const CLEAR_EXISTING_ISSUANCE = `${PERMIT_ACTION_PREFIX}CLEAR_EXISTING_ISSUANCE`;
export const GET_PERMIT_GALLERY = `${PERMIT_ACTION_PREFIX}GET_PERMIT_GALLERY`;
export const FETCH_ALT_PERMIT_HOLDER_DATA = `${PERMIT_ACTION_PREFIX}FETCH_ALT_PERMIT_HOLDER_DATA`;
export const SET_ALT_PERMIT_HOLDER_DATA = `${PERMIT_ACTION_PREFIX}SET_ALT_PERMIT_HOLDER_DATA`;
export const CLEAR_ERRORS = `${PERMIT_ACTION_PREFIX}CLEAR_ERRORS`;

// seasons
export const SEASON_MOD_SUCCESS = `${PERMIT_ACTION_PREFIX}SEASON_MOD_SUCCESS`;
export const SEASON_MOD_ERR = `${PERMIT_ACTION_PREFIX}SEASON_MOD_ERR`;
export const SEASON_ADD_SUCCESS = `${PERMIT_ACTION_PREFIX}SEASON_ADD_SUCCESS`;
export const SEASON_ADD_ERR = `${PERMIT_ACTION_PREFIX}SEASON_ADD_ERR`;
export const DISMISS_DISPLAY_SUCCESS_MESSAGE = `${PERMIT_ACTION_PREFIX}DISMISS_DISPLAY_SUCCESS_MESSAGE`;
export const DISMISS_DISPLAY_ERROR_MESSAGE = `${PERMIT_ACTION_PREFIX}DISMISS_DISPLAY_ERROR_MESSAGE`;

// availability
export const GET_AVAILABILITY = `${PERMIT_ACTION_PREFIX}GET_AVAILABILITY`;
export const FETCH_AVAILABILITY = `${PERMIT_ACTION_PREFIX}FETCH_AVAILABILITY`;

export const GET_DETAILED_AVAILABILITY = `${PERMIT_ACTION_PREFIX}GET_DETAILED_AVAILABILITY`;
export const GET_DETAILED_AVAILABILITY_ALL_QUOTA = `${PERMIT_ACTION_PREFIX}GET_DETAILED_AVAILABILITY_ALL_QUOTA`;
export const GET_DETAILED_AVAILABILITY_ERROR = `${PERMIT_ACTION_PREFIX}GET_DETAILED_AVAILABILITY_ERROR`;
export const FETCHING_DETAILED_AVAILABILITY = `${PERMIT_ACTION_PREFIX}GFETCHING_DETAILED_AVAILABILITY`;

export const UPDATE_QUOTA_TYPE = `${PERMIT_ACTION_PREFIX}UPDATE_QUOTA_TYPE`;

export const GET_AVAILABILITY_ERROR = `${PERMIT_ACTION_PREFIX}GET_AVAILABILITY_ERROR`;
export const CLEAR_AVAILABILITIES = `${PERMIT_ACTION_PREFIX}CLEAR_AVAILABILITIES`;
export const CLEAR_DETAILED_AVAILABILITY_ALL_QUOTA = `IW_CLEAR_DETAILED_AVAILABILITY_ALL_QUOTA`;
export const PROMPT_QUOTA_BORROWING = `${PERMIT_ACTION_PREFIX}PROMPT_QUOTA_BORROWING`;
export const PROMPT_QUOTA_BORROWING2 = `${PERMIT_ACTION_PREFIX}PROMPT_QUOTA_BORROWING2`;
export const CANCEL_QUOTA_BORROWING = `${PERMIT_ACTION_PREFIX}CANCEL_QUOTA_BORROWING`;
export const CANCEL_QUOTA_BORROWING2 = `${PERMIT_ACTION_PREFIX}CANCEL_QUOTA_BORROWING2`;
export const CHANGE_BORROW_REQUEST_AMOUNT = `${PERMIT_ACTION_PREFIX}CHANGE_BORROW_REQUEST_AMOUNT`;
export const CHANGE_BORROW_REQUEST_AMOUNT2 = `${PERMIT_ACTION_PREFIX}CHANGE_BORROW_REQUEST_AMOUNT2`;
export const SAVE_QUOTA_BORROWONG_MAP = `${PERMIT_ACTION_PREFIX}SAVE_QUOTA_BORROWONG_MAP`;
export const SAVE_QUOTA_BORROWONG_MAP2 = `${PERMIT_ACTION_PREFIX}SAVE_QUOTA_BORROWONG_MAP2`;

// issuance
export const POST_ISSUANCE = `${PERMIT_ACTION_PREFIX}POST_ISSUANCE`;
export const POST_ISSUANCE_ERROR = `${PERMIT_ACTION_PREFIX}POST_ISSUANCE_ERROR`;
export const POST_ISSUANCES_STATUS = `${PERMIT_ACTION_PREFIX}POST_ISSUANCES_STATUS`;
export const POST_ISSUANCES_STATUS_ERROR = `${PERMIT_ACTION_PREFIX}POST_ISSUANCES_STATUS_ERROR`;
export const POST_ISSUANCE_CALCULATE_FEES = `${PERMIT_ACTION_PREFIX}POST_ISSUANCE_CALCULATE_FEES`;
export const POST_ISSUANCE_CALCULATE_FEES_ERROR = `${PERMIT_ACTION_PREFIX}POST_ISSUANCE_CALCULATE_FEES_ERROR`;
export const POST_ISSUANCE_CARTLESS = `${PERMIT_ACTION_PREFIX}POST_ISSUANCE_CARTLESS`;
export const POST_ISSUANCE_CARTLESS_ERROR = `${PERMIT_ACTION_PREFIX}POST_ISSUANCE_CARTLESS_ERROR`;
export const UPDATE_ISSUANCE = `${PERMIT_ACTION_PREFIX}UPDATE_ISSUANCE`;
export const UPDATE_ISSUANCE_ERROR = `${PERMIT_ACTION_PREFIX}UPDATE_ISSUANCE_ERROR`;
export const GET_ISSUANCE = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE`;
export const GET_ISSUANCE_2 = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE_2`;
export const GET_ISSUANCE_ERROR = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE_ERROR`;
export const GET_ISSUANCE_BY_STATUS = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE_BY_STATUS`;
export const GET_ISSUANCE_BY_STATUS_ERROR = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE_BY_STATUS_ERROR`;
export const GET_ISSUANCE_PDF = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE_PDF`;
export const GET_ISSUANCE_PDF_ERROR = `${PERMIT_ACTION_PREFIX}GET_ISSUANCE_PDF_ERROR`;
export const CANCEL_ISSUANCE = `${PERMIT_ACTION_PREFIX}CANCEL_ISSUANCE`;
export const CANCEL_ISSUANCE_ERROR = `${PERMIT_ACTION_PREFIX}CANCEL_ISSUANCE_ERROR`;
export const SAVE_FILTERS = `${PERMIT_ACTION_PREFIX}SAVE_FILTERS`;
export const GET_USER_ISSUANCES = `${PERMIT_ACTION_PREFIX}GET_USER_ISSUANCES`;
export const GET_USER_ISSUANCES_ERROR = `${PERMIT_ACTION_PREFIX}GET_USER_ISSUANCES_ERROR`;
export const ISSUANCE_UPDATE_REQUIRES_PAYMENT = 'UpdateRequiresPayment';
export const ISSUANCE_UPDATE_SUCCESSFUL = 'UpdateSuccessful'; // go to confirmation page / populate redux
export const ISSUANCE_UPDATE_INPROGRESS = 'IW_ISSUANCE_UPDATE_INPROGRESS';
export const ISSUANCE_UPDATE_VALIDATION_ERROR = 'ValidationError';
export const CLEAR_ISSUANCE_BY_STATUS = `IW_CLEAR_ISSUANCE_BY_STATUS`;
export const CLEAR_ISSUANCES_BY_PERMIT = `IW_CLEAR_ISSUANCES_BY_PERMIT`;
export const CLEAR_POST_ISSUANCES_STATUS = `IW_CLEAR_POST_ISSUANCES_STATUS`;
export const CLEAR_FILTERS = `IW_CLEAR_FILTERS`;
export const CLEAR_RESERVATION = `IW_CLEAR_RESERVATION`;
export const CLEAR_POST_ISSUANCE = `IW_CLEAR_POST_ISSUANCE`;
export const INPROGRESS_ISSUANCE_UPDATED = `${PERMIT_ACTION_PREFIX}INPROGRESS_ISSUANCE_UPDATED`;
export const INPROGRESS_LOTTERY_ISSUANCE_UPDATED = `${PERMIT_ACTION_PREFIX}INPROGRESS_LOTTERY_ISSUANCE_UPDATED`;
export const SET_INPROGRESS_LOTTERY_ISSUANCE = `${PERMIT_ACTION_PREFIX}SET_INPROGRESS_LOTTERY_ISSUANCE`;
export const UPDATE_INPROGRESS_ISSUANCE_VALUES = `${PERMIT_ACTION_PREFIX}UPDATE_INPROGRESS_ISSUANCE_VALUES`;
export const DISPLAY_UI_VALIDATIONS = `${PERMIT_ACTION_PREFIX}DISPLAY_UI_VALIDATIONS`;
export const UPDATE_CALCULATED_LINE_ITEMS = `${PERMIT_ACTION_PREFIX}UPDATE_CALCULATED_LINE_ITEMS`;
export const UPDATE_RESERVATION_WITH_FEE = `${PERMIT_ACTION_PREFIX}UPDATE_RESERVATION_WITH_FEE`;
// Closures Constants
export const ADD_LOCATION_IN_INVENTORY_PAGE = `${PERMIT_ACTION_PREFIX}ADD_LOCATION_IN_INVENTORY_PAGE`;
export const REMOVE_LOCATION_IN_INVENTORY_PAGE = `${PERMIT_ACTION_PREFIX}REMOVE_LOCATION_IN_INVENTORY_PAGE`;
export const ADD_ALL_LOCATIONS_IN_INVENTORY_PAGE = `${PERMIT_ACTION_PREFIX}ADD_ALL_LOCATIONS_IN_INVENTORY_PAGE`;
export const REMOVE_ALL_LOCATIONS_IN_INVENTORY_PAGE = `${PERMIT_ACTION_PREFIX}REMOVE_ALL_LOCATIONS_IN_INVENTORY_PAGE`;

export const GET_ALL_LOCATIONS_CLOSURE = `${PERMIT_ACTION_PREFIX}GET_ALL_LOCATIONS_CLOSURE`;
export const GET_ALL_LOCATIONS_CLOSURE_ERROR = `${PERMIT_ACTION_PREFIX}GET_ALL_LOCATIONS_CLOSURE_ERROR`;

export const SET_CLOSURE = `${PERMIT_ACTION_PREFIX}SET_CLOSURE`;
export const CLEAR_CLOSURE = `${PERMIT_ACTION_PREFIX}CLEAR_CLOSURE`;
export const HANDLE_CLOSURE_CHANGE = `${PERMIT_ACTION_PREFIX}HANDLE_CLOSURE_CHANGE`;

export const SET_CLOSURE_RESERVATIONS = `${PERMIT_ACTION_PREFIX}SET_CLOSURE_RESERVATIONS`;
export const LOAD_RESERVATIONS_FOR_CLOSURE_ERROR = `${PERMIT_ACTION_PREFIX}LOAD_RESERVATIONS_FOR_CLOSURE_ERROR`;
export const POST_CLOSURE_SUCCESS = `${PERMIT_ACTION_PREFIX}POST_CLOSURE_SUCCESS`;
export const POST_CLOSURE_ERROR = `${PERMIT_ACTION_PREFIX}POST_CLOSURE_ERROR`;
export const LOAD_CLOSURE_ERROR = `${PERMIT_ACTION_PREFIX}LOAD_CLOSURE_ERROR`;
export const GET_DOWNLOAD_CLOSURE_REPORT_ERROR = `${PERMIT_ACTION_PREFIX}GET_DOWNLOAD_CLOSURE_REPORT_ERROR`;

export const CLOSURE_PERMIT_INVENTORY_TYPE = 'PERMIT';

// reservation types
export const FETCH_RESERVATION_START = `IW_FETCH_RESERVATION_START`;
export const FETCH_RESERVATION_SUCCESS = `IW_FETCH_RESERVATION_SUCCESS`;
export const FETCH_RESERVATION_FAILURE = `IW_FETCH_RESERVATION_FAILURE`;
export const CREATE_RESERVATION_START = `IW_CREATE_RESERVATION_START`;
export const CREATE_RESERVATION_SUCCESS = `IW_CREATE_RESERVATION_SUCCESS`;
export const CREATE_RESERVATION_FAILURE = `IW_CREATE_RESERVATION_FAILURE`;
export const UPDATE_RESERVATION_START = `IW_UPDATE_RESERVATION_START`;
export const UPDATE_RESERVATION_SUCCESS = `IW_UPDATE_RESERVATION_SUCCESS`;
export const UPDATE_RESERVATION_FAILURE = `IW_UPDATE_RESERVATION_FAILURE`;
export const UPDATE_CURRENT_RESERVATION = `IW_UPDATE_CURRENT_RESERVATION`;

// lottery
export const GET_LOTTERY = 'GET_LOTTERY';
export const GET_LOTTERY_ERROR = 'GET_LOTTERY_ERROR';
export const POST_LOTTERY = 'POST_LOTTERY';
export const POST_LOTTERY_ERROR = 'POST_LOTTERY_ERROR';
export const NOTIFY_LOTTERY_RESULTS = 'NOTIFY_LOTTERY_RESULTS';
export const NOTIFY_LOTTERY_RESULTS_ERROR = 'NOTIFY_LOTTERY_RESULTS_ERROR';
export const GET_LOTTERIES = 'GET_LOTTERIES';
export const GET_LOTTERIES_ERROR = 'GET_LOTTERIES_ERROR';
// campsite
export const GET_CAMPSITES = 'GET_CAMPSITES';
export const GET_CAMPSITES_ERROR = 'GET_CAMPSITES_ERROR';
export const GET_DIVISION_CAMPSITES = 'GET_DIVISION_CAMPSITES';
export const GET_DIVISION_CAMPSITES_ERROR = 'GET_DIVISION_CAMPSITES_ERROR';
export const SET_OVERNIGHT_CAMPSITE = 'SET_OVERNIGHT_CAMPSITE';
export const UNSET_OVERNIGHT_CAMPSITE = 'UNSET_OVERNIGHT_CAMPSITE';
export const CLEAR_OVERNIGHT_CAMPSITE = 'CLEAR_OVERNIGHT_CAMPSITE';

// account
export const GET_ACCOUNT_NAME = 'GET_ACCOUNT_NAME';
export const GET_ACCOUNT_NAME_ERROR = 'GET_ACCOUNT_NAME_ERROR';

// commercial guides
export const GET_ACCOUNT_EMPLOYEES = 'GET_ACCOUNT_EMPLOYEES';
export const GET_ACCOUNT_EMPLOYEES_ERROR = 'GET_ACCOUNT_EMPLOYEES_ERROR';

// reservation detail
export const PERMIT = 'PERMIT';
export const LOTTERY = 'LOTTERY';

export const SEND_CURRENT_DATE = 'SEND_CURRENT_DATE';

export const EPOCH_MULTIPLIER = 1000;

// alternate permit holder
export const VERIFY_ALTERNATE = `${PERMIT_ACTION_PREFIX}VERIFY_ALTERNATE`;
export const VERIFY_ALTERNATE_ERROR = 'VERIFY_ALTERNATE_ERROR';
export const CONFIRM_ALTERNATE = `${PERMIT_ACTION_PREFIX}CONFIRM_ALTERNATE`;
export const CONFIRM_ALTERNATE_ERROR = `${PERMIT_ACTION_PREFIX}CONFIRM_ALTERNATE_ERROR`;
export const DECLINE_ALTERNATE = `${PERMIT_ACTION_PREFIX}DECLINE_ALTERNATE`;
export const DECLINE_ALTERNATE_ERROR = `${PERMIT_ACTION_PREFIX}DECLINE_ALTERNATE_ERROR`;

// fee display models
export const ONE_FEE = 'OneFee';
export const ADD_ON_FEE = 'AddOnFee';

// fee calculation models
export const NO_USE_FEE = 'NoUseFee';
export const FLAT_USE_FEE = 'FlatUseFee';
export const PER_GROUP_PER_NIGHT_FEE = 'PerGroupPerNight';
export const PER_GROUP_PER_DAY_FEE = 'PerGroupPerDay';
export const PER_MEMBER_FEE = 'PerMember';
export const PER_MEMBER_PER_NIGHT_FEE = 'PerMemberPerNight';
export const PER_MEMBER_PER_DAY_FEE = 'PerMemberPerDay';
export const PER_WATERCRAFT_FEE = 'PerWatercraft';
export const PER_GROUP_PER_NIGHT_CUSTOM_RANGE_HIGH_USE_ONLY_FEE = 'PerGroupPerNightCustomRangeHighUseOnly';

// fee types
export const RESERVATION_FEE = 'ReservationFee';
export const USE_FEE = 'UseFee';
export const ADULT_USE_FEES = 'AdultUseFee';
export const CHILD_USE_FEES = 'ChildUseFee';
export const INTER_ACCESS_USE_FEES = 'IAPUseFee';
export const INTER_SENIOR_USE_FEES = 'ISPUseFee';
export const INTER_YOUTH_USE_FEES = 'IYAPUseFee';
export const SPH_USE_FEES = 'SeasonPassUseFee';
export const TCH_USE_FEES = 'TreatyPassUseFee';
export const TOTAL_USE_FEE = 'TotalUseFee';
export const MIN_BALANCE_FEE = 'MinBalanceUseFee';
export const POS_FEE = 'POSFee';
export const TAX_FEE = 'TaxFee';
export const NONREFUNDABLE_FEE = 'NonRefundable';

export const SKU_ADULT_USE_FEE = 'PERUSE233262ADULT';
export const SKU_CHILD_USE_FEE = 'PERUSE233262CHILD';
export const SKU_IAP_USE_FEE = 'PERUSE233262IAP';
export const SKU_ISP_USE_FEE = 'PERUSE233262ISP';
export const SKU_IYAP_USE_FEE = 'PERUSE233262IYAP';
export const SKU_SPH_USE_FEE = 'PERUSE233262SPH';
export const SKU_TCH_USE_FEE = 'PERUSE233262TCH';
export const SKU_MIN_BALANCE_FEE = 'PERMIN233262';
export const SKU_TX_FEE = 'PERRES233262';
export const SKU_TX_FEE_WHITNEY = 'PERRES233260';
export const SKU_USE_FEE = 'PERUSE233262';

export const DIV_TYPE_EP = 'Entry Point';
export const DIV_CREST_EXIT_CODE = 'JM35';

export const ADULT_FEE_TYPE = '1';
export const CHILD_FEE_TYPE = '2';
export const INTER_SENIOR_FEE_TYPE = '3';
export const INTER_ACCESS_FEE_TYPE = '4';
export const INTER_YOUTH_ACCESS_FEE_TYPE = '5';
export const SEASON_CARD_FEE_TYPE = '6';
export const TREATY_CARD_FEE_TYPE = '7';

export const RES_ID_DELIMITER = '__';

// cart
export const GET_CART = 'GET_CART';
export const GET_CART_ERROR = 'GET_CART_ERROR';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const CANCEL_RESERVATION_ERROR = 'CANCEL_RESERVATION_ERROR';

// issuance readable statuses
export const PERMIT_PRELIMINARY_READABLE = 'Preliminary';
export const PERMIT_IN_PROGRESS_READABLE = 'In Progress';
export const PERMIT_COMPLETE_READABLE = 'Reserved';
export const PERMIT_ISSUED_READABLE = 'Issued';
export const PERMIT_NO_SHOW_READABLE = 'No Show';
export const PERMIT_CANCELLED_READABLE = 'Cancelled';
export const PERMIT_VOIDED_READABLE = 'Voided';

// issuance types
export const PRIVATE = 'Non-Commercial';
export const COMMERCIAL = 'Commercial';

// internal validations
export const IS_LOTTERY_NAME_EMPTY = 'IsLotteryNameEmpty';
export const IS_LOTTERY_START_DATE_EMPTY = 'IsLotteryStartDateEmpty';
export const IS_LOTTERY_CLOSE_DATE_EMPTY = 'IsLotteryCloseDateEmpty';
export const IS_LOTTERY_RUN_DATE_EMPTY = 'IsLotteryRunDateEmpty';
export const IS_LOTTERY_DEADLINE_DATE_EMPTY = 'IsLotteryDeadlineDateEmpty';
export const IS_LOTTERY_INFO_DISPLAY_DATE_EMPTY = 'IsLotteryInfoDisplayDateEmpty';
export const IS_LOTTERY_NOTIFY_DATE_EMPTY = 'IsLotteryNotifyDateEmpty';
export const IS_SEASON_START_DATE_EMPTY = 'IsSeasonStartDateEmpty';
export const IS_SEASON_END_DATE_EMPTY = 'IsSeasonEndDateEmpty';

// external validations
export const IS_LAUNCH_LOCATION_EMPTY = 'IsLaunchLocationEmpty';
export const IS_TAKEOUT_LOCATION_EMPTY = 'IsTakeoutLocationEmpty';
export const IS_ISSUE_STATION_EMPTY = 'IsIssueStationEmpty';
export const IS_ENTRY_DATE_EMPTY = 'IsEntryDateEmpty';
export const IS_EXIT_DATE_EMPTY = 'IsExitDateEmpty';
export const IS_GROUP_MEMBER_EMPTY = 'IsGroupMemberEmpty';
export const IS_EQUIPMENT_EMPTY = 'IsEquipmentEmpty';
export const IS_NEED_TO_KNOW_CHECKED = 'IsNeedToKnowChecked';

// validation targets
export const ENTRY_POINT = 'entryPoint';
export const EXIT_POINT = 'exitPoint';
export const ISSUE_STATION = 'issueStation';
export const GROUP_MEMBERS = 'groupMembers';
export const WATERCRAFTS = 'watercrafts';
export const EXIT_DATE = 'exitDate';
export const LOTTERY_OPEN_DATE = 'lotteryOpenDate';
export const LOTTERY_CLOSE_DATE = 'lotteryCloseDate';
export const LOTTERY_RUN_DATE = 'lotteryRunDate';
export const LOTTERY_DEADLINE_DATE = 'lotteryDeadlineDate';
export const LOTTERY_INFO_DISPLAY_DATE = 'lotteryInfoDisplayDate';
export const LOTTERY_NOTIFY_DATE = 'lotteryNotifyDate';
export const SEASON_START_DATE = 'lotterySeasonStartDate';
export const SEASON_END_DATE = 'lotterySeasonEndDate';
export const NEED_TO_KNOW_CHECKBOX = 'needToKnowChecked';
export const DIVISION_ID = 'divisionId';
export const SELECTED_DATES = 'selectedDates';

// Rule Types
export const QUOTA_TYPE = 'QUOTA_TYPE';
export const GET_RULES_BY_YEARS = 'GET_RULES_BY_YEARS';
export const GET_RULES_BY_YEARS_ERROR = 'GET_RULES_BY_YEARS_ERROR';

// permissions
export const GET_PERMISSION = 'getPermission';
export const NOT_ALLOWED = 'notAllowed';

// validation types
export const REQUIRED_BOOLEAN_FIELD = 'REQUIRED_BOOLEAN_FIELD';
export const REQUIRED_STRING_FIELD = 'REQUIRED_STRING_FIELD';
export const REQUIRED_DATE_FIELD = 'REQUIRED_DATE_FIELD';
export const REQUIRED_LIST_FIELD = 'REQUIRED_LIST_FIELD';
export const REQUIRED_NUM_FIELD = 'REQUIRED_NUM_FIELD';
export const REQUIRED_LIST_ENTRY_FIELD = 'REQUIRED_LIST_ENTRY_FIELD';

export const PERMIT_REGISTRATION = 'PermitRegistration';
export const LOTTERY_REGISTRATION = 'LotteryRegistration';
export const REGISTRATION = 'Registration';

// detailed availability
export const AVAILABILITY_DAYS_TO_DISPLAY = 5;
export const AVAILABILITY_DAYS_TO_SKIP = 5;
export const AVAILABILITY_DAYS_TO_DISPLAY_MOBILE = 4;
export const AVAILABILITY_DAYS_TO_SKIP_MOBILE = 4;
export const AVAILABILITY_UNSELECTED = 'AVAILABILITY_UNSELECTED';
export const AVAILABILITY_START_MULTIDAY = 'AVAILABILITY_START_MULTIDAY';
export const AVAILABILITY_CONTINUE_MULTIDAY = 'AVAILABILITY_CONTINUE_MULTIDAY';
export const AVAILABILITY_END_MULTIDAY = 'AVAILABILITY_END_MULTIDAY';
export const AVAILABILITY_SINGLE_DAY = 'AVAILABILITY_SINGLE_DAY';

export const GROUP_AVAILABILITY_DAILY_KEY_NAME = 'ConstantQuotaUsageDaily';
export const GROUP_AVAILABILITY_KEY_NAME = 'ConstantQuotaUsageByStartDate';
export const MEMBER_AVAILABILITY_KEY_NAME = 'QuotaUsageByMember';
export const AGGREGATE_AVAILABILITY_KEY_NAME = 'AggregateQuota';
export const WATERCRAFT_AVAILABILITY_KEY_NAME = 'QuotaUsageByWatercraft';
export const FILTER_NUMERICAL = 'numerical';

// common date format strings
export const DATE_FORMAT = 'ddd, MMM D, YYYY';
export const DATE_TIME_FORMAT = 'ddd, MMM D, YYYY | hh:mmA z';
export const MONTH_DAY_YEAR_FORMAT = 'MMM Do YYYY';
export const AVAILABILITY_KEY_MAP_FORMAT = 'YYYY-MM-DD';
export const INTERNAL_AVAILABILITY_KEY_MAP_FORMAT = 'MM/DD/YYYY';
export const MONTH_DAY_YEAR_NUM_FORMAT = 'MM/DD/YYYY';

// sales channel types
export const ONLINE = 'ONLINE';
export const FIELD_SALES = 'FIELD_SALES';
export const CALL_CENTER = 'CALL_CENTER';

export const SEASON_TYPES = {
  Lottery: 'Lottery',
  High: 'High'
}

// division status enum
export const DIVISION_STATUS = {
  CLOSED: 0,
  OPEN: 1
};

export const FINALIZE_CHECKOUT = 'FINALIZE_CHECKOUT';
export const CLEAR_ISSUANCE = 'CLEAR_ISSUANCE';

// permit types enum
export const PERMIT_TYPE_RIVER = 'PERMIT_TYPE_RIVER';
export const PERMIT_TYPE_HIKING = 'PERMIT_TYPE_HIKING';
export const PERMIT_TYPE_CAMPING = 'PERMIT_TYPE_CAMPING';
export const PERMIT_TYPE_CLIMBING = 'PERMIT_TYPE_CLIMBING';
export const PERMIT_TYPE_WILDLIFE = 'PERMIT_TYPE_WILDLIFE';
export const PERMIT_TYPE_ROADENTRY = 'PERMIT_TYPE_ROADENTRY';
export const PERMIT_TYPE_EVENT = 'PERMIT_TYPE_EVENT';
export const PERMIT_TYPE_BOAT = 'PERMIT_TYPE_BOAT';
export const PERMIT_TYPE_SNOWMOBILE = 'PERMIT_TYPE_SNOWMOBILE';
export const PERMIT_TYPE_WILDERNESS = 'PERMIT_TYPE_WILDERNESS';

// login
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';

// Error Messages
export const ERROR_UNAUTHORIZED = 'You are not authorized to access this page.';
export const ERROR_DEFAULT = 'Something went wrong, please try again later.';

// SEASON_ENUM
export const SEASON_ENUM = {
  LowSeason: 'LowSeason',
  HighSeason: 'HighSeason'
};

// Certifications
export const GET_CERTIFICATIONS = 'GET_CERTIFICATIONS';
export const GET_CERTIFICATIONS_ERROR = 'GET_CERTIFICATIONS_ERROR';

// Internal Editing Quotas for Dates
export const ADD_DETAILED_AVAILABILITY_TO_EDIT = `${PERMIT_ACTION_PREFIX}ADD_DETAILED_AVAILABILITY_TO_EDIT`;
export const ADD_DETAILED_AVAILABILITY_TO_EDIT_BULK = `${PERMIT_ACTION_PREFIX}ADD_DETAILED_AVAILABILITY_TO_EDIT_BULK`;
export const POST_DETAILED_AVAILABILITY = `${PERMIT_ACTION_PREFIX}POST_DETAILED_AVAILABILITY`;
export const POST_DETAILED_AVAILABILITY_ERROR = `${PERMIT_ACTION_PREFIX}POST_DETAILED_AVAILABILITY_ERROR`;

export const ERROR_LOTTERY_NOT_OPEN = 'This lottery is not open for applications yet.'
